import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import Layout from '../components/feature/Layout';

const Products2Page = lazy(() => import('../pages/products2/page'));
const StorePage = lazy(() => import('../pages/store/page'));
const DealerPage = lazy(() => import('../pages/dealer/page'));
const DeveloperPage = lazy(() => import('../pages/developer/page'));
const AgreementPage = lazy(() => import('../pages/agreement/page'));

const Spin = () => (
  <div className="w-full min-h-screen flex items-center justify-center bg-black">
    <div className="w-6 h-6 rounded-full border-2 border-white/20 border-t-white animate-spin" />
  </div>
);

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/NIMO',
        element: (
          <Suspense fallback={<Spin />}>
            <Products2Page />
          </Suspense>
        ),
      },
      {
        path: '/store',
        element: (
          <Suspense fallback={<Spin />}>
            <StorePage />
          </Suspense>
        ),
      },
      {
        path: '/dealer',
        element: (
          <Suspense fallback={<Spin />}>
            <DealerPage />
          </Suspense>
        ),
      },
      {
        path: '/agreement',
        element: (
          <Suspense fallback={<Spin />}>
            <AgreementPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/developer',
    element: (
      <Suspense fallback={<Spin />}>
        <DeveloperPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
